<template>
  <a-card :bordered="false" :bodyStyle="{paddingTop:'0px'}"
          :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-row slot="title">
      <a-col :span="24" style="cursor: pointer;">
        <span @click="goBack">匹配详情</span>>{{ proName }}(产品ID:{{ proId }})
      </a-col>
    </a-row>
    <a-table
      :columns="getProColumns()"
      rowKey="erpHotelId"
      :dataSource="productList" :pagination="false">
      <template slot="latSlots" slot-scope="text, record">
        <div>经:{{ record.longitude }}</div>
        <div>纬:{{ record.latitude }}</div>
      </template>
    </a-table>
    <a-row class="magin-data">
      <a-col :span="20" class="load-tips">
        <span class="tips-txt">匹配到产品信息</span>
        <span class="tips-color">*注意：请仔细比对产品信息，如与上述基础数据不一致，请及时处理！</span>
      </a-col>
      <a-col :span="4" class="text-r">
        <a-button type="primary" @click="handleUpdata">重新匹配</a-button>
      </a-col>
    </a-row>
    <a-table
      :columns="getMatchProColumns()"
      rowKey="hotelId"
      :dataSource="matchProductList" :pagination="false">
      <template slot="latSlots" slot-scope="text, record">
        <div>经:{{ record.longitude }}</div>
        <div>纬:{{ record.latitude }}</div>
      </template>
      <template slot="action" slot-scope="text, record">已匹配</template>
    </a-table>
    <a-row class="magin-data">
      <a-col :span="20" class="load-tips">
        <span class="tips-txt">该产品共有{{ optionLength }}个房型</span>
      </a-col>
    </a-row>
    <a-table
      :columns="getHotelRoomColumns()"
      rowKey="optionId"
      :dataSource="optionList" :pagination="false">
    </a-table>
    <a-row class="magin-data">
      <a-button @click="goBack">返回</a-button>
    </a-row>
  </a-card>
</template>

<script>
export default {
  name: 'HotelMatchDetail',
  data() {
    return {
      proName: this.$route.query.proName,
      proId: this.$route.query.proId,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      productList: [],
      matchProductList: [],
      optionList: [],
      optionLength: 0
    }
  },
  mounted() {
  },
  activated() {
    this.proId = this.$route.query.proId
    this.proName = this.$route.query.proName
    this.getDetailList()
  },
  deactivated() {

  },
  methods: {
    // 获取表格数据接口
    getDetailList() {
      let params = {
        erpHotelId: this.proId,
        merchantId: this.merchantId,
        platformId: this.platformId,
        searchOption: true
      }
      this.getHttpServices().getCloudProService().post('erp/search/findErpHotelMatchDetails', params).then(res => {
        if (res.erpHotelInfo) {
          this.productList = [res.erpHotelInfo]
        }
        if (res.matchHotelInfo && res.matchHotelInfo.length > 0) {
          this.matchProductList = res.matchHotelInfo
          let arr = []
          res.matchHotelInfo.forEach(item => {
            if (item.matchHotelOptionList && item.matchHotelOptionList.length > 0) {
              this.getLogUtils().logWithTag('matchHotelOptionList', item.matchHotelOptionList)
              item.matchHotelOptionList.forEach(item2 => {
                arr.push(item2)
              })
            }
          })
          this.optionList = arr
          this.optionLength = this.optionList.length
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    goBack() {
      this.$router.go(-1)
    },
    getProColumns() {
      return [
        {
          title: '产品ID ',
          dataIndex: 'erpHotelId'
        },
        {
          title: '产品名称',
          dataIndex: 'hotelName'
        },
        {
          title: '所在城市',
          dataIndex: 'cityName'
        },
        {
          title: '联系电话',
          dataIndex: 'hotelPhone'
        },
        {
          title: '地址',
          dataIndex: 'hotelAddress'
        },
        {
          title: '经纬度',
          dataIndex: 'Latitude',
          scopedSlots: { customRender: 'latSlots' }
        },
        {
          title: '状态',
          dataIndex: 'hotelStatusStr'
        },
        {
          title: '匹配状态',
          dataIndex: 'matchStatusStr'
        }
      ]
    },
    getMatchProColumns() {
      return [
        {
          title: '产品ID ',
          dataIndex: 'hotelId'
        },
        {
          title: '产品名称',
          dataIndex: 'hotelName'
        },
        {
          title: '所在城市',
          dataIndex: 'cityName'
        },
        {
          title: '联系电话',
          dataIndex: 'hotelPhone'
        },
        {
          title: '地址',
          dataIndex: 'hotelAddress'
        },
        {
          title: '经纬度',
          dataIndex: 'Latitude',
          scopedSlots: { customRender: 'latSlots' }
        },
        {
          title: '状态',
          dataIndex: 'hotelStatusStr'
        },
        {
          title: '匹配状态',
          scopedSlots: { customRender: 'action' }
        }
      ]
    },
    getHotelRoomColumns() {
      return [
        {
          title: '房型ID  ',
          dataIndex: 'optionId'
        },
        {
          title: '房型',
          dataIndex: 'optionName'
        },
        {
          title: '状态',
          dataIndex: 'optionStatusStr'
        }
      ]
    },
    handleUpdata() {
      this.$router.push({
        name: 'HotelhandleMatch',
        query: {
          proId: this.proId,
          proName: this.proName,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    }
  }

}
</script>
<style scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.price-class {
  color: #fea834;
}

.text-r {
  text-align: right;
}

.load-tips {
  display: flex;
  height: 32px;
  align-items: center;
}

.tips-txt {
  font-size: 18px;
  font-weight: 500;
}

.tips-color {
  color: #FE8534;
}

.magin-data {
  margin-bottom: 20px;
  margin-top: 15px;
}
</style>